<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import _find from 'lodash/find'
import _filter from 'lodash/filter'
import _clone from 'lodash/clone'

import INVENTORY_TYPES from 'constants/inventoryTypes'
import WEIGHT_UNIT_ABBREVIATIONS from 'constants/weightUnitAbbreviations'
import orderCartService from 'api/orderCart'
import dateUtils from 'utils/dateUtils'
import CANNABIS_TYPES from 'constants/cannabisTypes'
import CANNABIS_TYPE_NAMES from 'constants/cannabisTypeNames'

export default {
  name: 'item-card',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      items: (state) => state.checkout.items,
      inventory: (state) => state.inventory.current,
    }),
    thcContentUnit() {
      if (this.item.thcContentUnit) return this.item.thcContentUnit

      if ([INVENTORY_TYPES.FLOWER, INVENTORY_TYPES.PRE_ROLLS, INVENTORY_TYPES.VAPORIZERS].includes(this.item.type)) {
        return '%'
      }

      return 'mg'
    },
    cbdContentUnit() {
      if (this.item.cbdContentUnit) return this.item.cbdContentUnit

      if ([INVENTORY_TYPES.FLOWER, INVENTORY_TYPES.PRE_ROLLS, INVENTORY_TYPES.VAPORIZERS].includes(this.item.type)) {
        return '%'
      }

      return 'mg'
    },
    itemWeight() {
      return this.item.weightFormatted
    },
    showThcContent() {
      return this.item.thcMin
    },
    showThcRange() {
      return this.item.thcMax
    },
    showCbdContent() {
      return this.item.cbdMin
    },
    showCbdRange() {
      return this.item.cbdMax
    },
  },
  data() {
    return {
      INVENTORY_TYPES,
      WEIGHT_UNIT_ABBREVIATIONS,
      CANNABIS_TYPES,
      CANNABIS_TYPE_NAMES,
      dropdownOpen: false,
    }
  },
  methods: {
    getWeightsWithQuantity(weights) {
      weights = _filter(weights, (weight) => {
        return weight.quantity > 0 && weight.enable
      })

      return weights
    },
    onDropdownOpen() {
      this.dropdownOpen = true
    },
    onDropdownHide() {
      this.dropdownOpen = false
    },
    onImageLoaded() {
      this.$emit('load')
    },
    selectItem() {
      this.$emit('clicked')
    },
    addItemToCart(id) {
      const inventoryId = id
      const quantity = 1

      const items = this.items.map((item) => {
        return _clone(item)
      })

      const existingItem =
        _find(items, {
          inventoryId,
        }) || null

      const totalQuantity = (existingItem ? existingItem.quantity || 0 : 0) + quantity

      if (existingItem) {
        existingItem.quantity = totalQuantity
      } else {
        items.push({
          inventoryId,
          quantity: totalQuantity,
        })
      }

      return orderCartService
        .createByVenueId(this.venue.id, {
          date: dateUtils.toUTCTimestampWithoutTime(this.date),
          items: items.map((i) => {
            return {
              inventoryId: i.inventoryId,
              quantity: parseInt(i.quantity, 10),
            }
          }),
        })
        .then(() => {
          this.$store.dispatch('addCartItem', {
            inventoryId,
            inventory: this.item,
            quantity,
          })

          if (this.$refs.dropdownEl) {
            this.$refs.dropdownEl.hide()
          }

          return null
        })
        .catch((error) => {
          this.$store.dispatch('addTopBarNotification', {
            text: error.message,
          })

          return null
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ItemCard/index.vue